import { TaskPriorityUnionType } from '@api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getTaskPriorityPresentation } from '@common';

type TaskPriorityPropsType = {
  priority: TaskPriorityUnionType;
};

export const TaskPriority: React.FC<TaskPriorityPropsType> = ({ priority }) => {
  const { t } = useTranslation('tasks');
  const priorityPresentation = getTaskPriorityPresentation(priority);
  const priorityLabel = t(`PRIORITY.${priorityPresentation.labelKey}`);

  return (
    <Tooltip
      label={priorityLabel}
      position="right"
      transitionProps={{ duration: 200 }}
      bg="layout.10"
      p="xs"
      offset={8}
    >
      <Box
        display="flex"
        pt={5}
        style={{ flexShrink: 0, lineHeight: 1 }}
        aria-label={priorityLabel}
      >
        <FontAwesomeIcon
          icon={priorityPresentation.icon}
          size="xs"
          color={priorityPresentation.color}
        />
      </Box>
    </Tooltip>
  );
};
